{
  "ui": {
    "sceneCanvas": "Spielszene – Hotspots per Klick oder Tap untersuchen",
    "loadError": "Das Spiel konnte nicht geladen werden.",
    "cantUse": "Das funktioniert so nicht.",
    "cantCombine": "Das passt nicht zusammen.",
    "coasterFound": "Ein seltener Bierdeckel für Hinnerks Sammlung!"
  },
  "menu": {
    "kicker": "Ein Hafenkneipen-Abenteuer",
    "title": "Die letzte Runde",
    "subtitle": "Wissen ist der Schlüssel.",
    "play": "Spielen",
    "loading": "Lädt …",
    "guide": "Demo-Anleitung",
    "guideTitle": "Demo-Anleitungen (PDF)",
    "noGuides": "Noch keine Anleitung vorhanden.",
    "newest": "aktuell",
    "about": "Über das Spiel",
    "aboutText": "Ein ruhiges Point-and-Click-Abenteuer, in dem Quizfragen die Rätsel lösen. Alle Grafiken, Animationen und Klänge entstehen per Code. Fragen sind recherchiert und mit Quellen versehen.",
    "back": "Zurück",
    "continue": "Weiterspielen",
    "newGame": "Neues Spiel",
    "saves": "Spielstände",
    "save": "Speichern",
    "load": "Laden",
    "emptySlot": "leer",
    "slot": {
      "auto": "Automatisch",
      "slot1": "Platz 1",
      "slot2": "Platz 2",
      "slot3": "Platz 3"
    },
    "quizNight": "Quizabend (Partyspiel)",
    "settings": "Einstellungen",
    "partyMode": "Partymodus (TV + Handys)",
    "daily": "Tagesrätsel",
    "chapters": "Kapitel wählen",
    "current": "aktuell",
    "online": "Online-Pubquiz",
    "account": "Konto",
    "install": "Als App installieren",
    "fullscreen": "Vollbild",
    "offline": "Offline – Abenteuer, Quizabend allein, Training und Kneipenspiele gehen trotzdem."
  },
  "hud": {
    "menu": "Menü",
    "hotspots": "Hotspots zeigen",
    "inventory": "Inventar",
    "inventoryEmpty": "Taschen leer",
    "useItem": "{item} benutzen mit …",
    "quests": "Aufgaben",
    "noQuests": "Gerade nichts zu tun – schau dich um.",
    "hint": "Hinweis",
    "noHint": "Gerade gibt es keine offene Aufgabe – schau dich einfach um.",
    "hintLevel": [
      "Wink",
      "Tipp",
      "Lösung"
    ],
    "hintMore": [
      "Wink anzeigen",
      "Tipp anzeigen",
      "Lösung verraten"
    ],
    "sideQuests": "Nebenaufgaben"
  },
  "quiz": {
    "later": "Später versuchen",
    "progress": "{n} von {need} richtig",
    "options": "Antwortmöglichkeiten",
    "right": "✓ Richtig!",
    "wrong": "✗ Leider nicht.",
    "source": "Quelle",
    "next": "Weiter",
    "open": "Öffnen",
    "estimate": "Schätzwert",
    "estimateExact": "Genauer Wert",
    "lockIn": "Einloggen",
    "orderHint": "Bringe die Einträge in die richtige Reihenfolge.",
    "orderList": "Reihenfolge",
    "up": "nach oben",
    "down": "nach unten",
    "numlock": "Zahlenschloss",
    "tryCode": "Code probieren",
    "solution": "Lösung",
    "continue": "Weiter",
    "lockedIn": "Antwort eingeloggt ✓",
    "imageAlt": "Bild zur Frage",
    "play": "Abspielen",
    "playing": "Läuft …",
    "audioText": "Als Text anzeigen",
    "match": "Zuordnung",
    "choose": "– wählen –",
    "gap": "Lücke {n}",
    "hintRange": "Tipp: zwischen {lo} und {hi} {unit}",
    "solvedByHint": "💡 Mit Hinweis gelöst",
    "hintBtn": [
      "Wink",
      "Tipp",
      "Lösung"
    ],
    "joker": "Stammgast fragen",
    "jokerLine": [
      "Gesa raunt: „Zwei davon kannst du vergessen, Deern.“",
      "Ole brummt: „Ich sag nix … aber die Hälfte ist Quatsch.“",
      "Jan flüstert: „Wenn ich du wär, würd ich weniger raten.“"
    ],
    "kiHint": "Von der KI ergänzt und automatisch gegengeprüft – ohne Quelle. Fehler bitte melden.",
    "itemUp": "„{item}“ (Platz {pos}) nach oben",
    "itemDown": "„{item}“ (Platz {pos}) nach unten",
    "digitN": "Ziffer {n}: {d}",
    "digitUp": "Ziffer {n} erhöhen (jetzt {d})",
    "digitDown": "Ziffer {n} verringern (jetzt {d})"
  },
  "end": {
    "kicker": "Vorhang",
    "stay": "Weiter umsehen",
    "menu": "Hauptmenü",
    "startShow": "Quizabend starten",
    "next": "Weiter zum nächsten Kapitel"
  },
  "dialog": {
    "yourAnswer": "Deine Antwort"
  },
  "show": {
    "title": "Quizabend im Rostigen Anker",
    "close": "Quizabend beenden",
    "progress": "Runde {r}/{rr} · Frage {q}/{qq}",
    "finalRound": "Schlussrunde",
    "setupTitle": "Wer spielt heute mit?",
    "setupLead": "Ein Gerät, bis zu vier Teams. Am besten am Fernseher oder Laptop – das Gerät wird für die Antworten herumgereicht.",
    "teams": "Anzahl Teams",
    "teamName": "Name von Team {n}",
    "teamNames": [
      "Die Heringsbändiger",
      "Klabautermänner",
      "Leuchtfeuer",
      "Möwenschiss & Co."
    ],
    "mode": "Spielweise",
    "modeAll": "Alle antworten",
    "modeTurns": "Reihum",
    "modeAllHint": "Jede Frage für alle Teams – das Gerät wird verdeckt weitergereicht.",
    "modeTurnsHint": "Jede Frage geht an ein Team, die Teams wechseln sich ab.",
    "length": "Länge",
    "lenNormal": "Ganzer Abend (6 × 8 Fragen)",
    "lenShort": "Kurz (3 × 4 Fragen)",
    "start": "Quizabend beginnen",
    "welcome": "Moin und willkommen!",
    "rules": "{r} Runden à {q} Fragen, danach die Schlussrunde mit Einsatz. Schätzfragen: Wer am nächsten dran ist, bekommt einen Bonuspunkt.",
    "letsGo": "Glocke läuten – los geht’s!",
    "round": "Runde {n}",
    "firstQuestion": "Zur ersten Frage",
    "passDevice": "Gerät weitergeben an",
    "yourTurn": "Diese Frage geht an",
    "othersLookAway": "Alle anderen: kurz wegschauen!",
    "ready": "Wir sind bereit",
    "nextTeam": "Weiter zum nächsten Team",
    "toReveal": "Zur Auflösung",
    "solution": "Auflösung",
    "bonus": "(am nächsten dran)",
    "next": "Nächste Frage",
    "toAwards": "Zur Siegerehrung",
    "standingsAfter": "Zwischenstand nach Runde {n}",
    "nextRound": "Nächste Runde",
    "toFinal": "Zur Schlussrunde",
    "wagerTitle": "Wie viel setzt ihr?",
    "wagerLead": "Eine letzte Frage aus „{cat}“. Richtig: Einsatz dazu. Falsch: Einsatz weg. Maximal so viel, wie ihr habt.",
    "wagerOf": "Einsatz von {team}",
    "wagerOk": "Einsätze stehen!",
    "awards": "Siegerehrung",
    "again": "Neuer Abend",
    "backToPub": "Zurück in die Kneipe",
    "mod": {
      "welcome": [
        "Moin, moin! Schön, dass ihr da seid – {n} Teams, ein Abend, jede Menge Fragen. Hinnerk wäre stolz.",
        "Willkommen im Rostigen Anker! Handys weg, Köpfe an. Und nein, Gesa, du darfst nicht googeln.",
        "Die Glocke ist poliert, die Fragen sind frisch recherchiert. Möge das klügste Team gewinnen!"
      ],
      "round": [
        "Runde {n}: {cat}! Wer hier punktet, hat’s drauf.",
        "Runde {n} – heute geht’s um {cat}. Ich hoffe, ihr habt aufgepasst im Leben.",
        "Und weiter mit Runde {n}: {cat}. Konzentration, bitte – auch an Tisch drei."
      ],
      "allRight": [
        "Alle richtig! Entweder seid ihr genial oder die Frage war zu leicht.",
        "Einstimmig richtig – das gab’s zuletzt 1987.",
        "Wunderbar, alle wissen es! Hinnerk hätte die Frage sofort gestrichen."
      ],
      "someRight": [
        "Stark, {team}! Der Rest: Kopf hoch.",
        "{team} weiß Bescheid. Die anderen nicken jetzt so, als hätten sie’s auch gewusst.",
        "Punkt für {team}! Applaus, bitte."
      ],
      "noneRight": [
        "Niemand? Gar niemand? Na gut, dafür gibt’s ja die Erklärung.",
        "Uff. Diese Frage hat alle versenkt. Volle Fahrt voraus zur nächsten!",
        "Keiner wusste es – ich hab’s auch erst beim Recherchieren gelernt."
      ],
      "standings": [
        "Zwischenstand! {team} führt mit {pts} Punkten. Aber der Abend ist noch jung.",
        "{team} vorne – noch ist alles drin für die anderen.",
        "Ein Blick auf die Tafel: {team} segelt vorneweg."
      ],
      "beforeFinal": [
        "Alle Runden gespielt! {team} führt – aber jetzt kommt die Schlussrunde mit Einsatz.",
        "Gleich wird’s spannend: Schlussrunde! {team} hat die Nase vorn."
      ],
      "wager": [
        "Setzt klug – oder setzt alles. Hinnerk hat immer alles gesetzt. Und meistens verloren.",
        "Wie mutig seid ihr? Eure Punkte, euer Risiko."
      ],
      "final": [
        "Die letzte Frage des Abends. Gerät weitergeben – und gut nachdenken!",
        "Jetzt zählt’s. Eine Frage, alle Einsätze."
      ],
      "awards": [
        "Und der Sieg geht an … {team}! Eine Runde aufs Haus. Also … fast.",
        "Glückwunsch, {team}! Euer Name kommt an die Kreidetafel.",
        "{team} gewinnt den Abend! Ding, ding, ding!"
      ],
      "themeWait": [
        "„{topic}“? Moment, ich blättere in Hinnerks Archiv …",
        "Gesa, halt mal kurz die Glocke – ich such noch Fragen zu „{topic}“!",
        "Gleich geht’s los … die Kartei zu „{topic}“ klemmt ein bisschen.",
        "Ich frag mal eben Ole, der weiß alles über „{topic}“ … fast alles."
      ]
    },
    "themeTitle": "Themenrunde auf Zuruf (optional)",
    "themePlaceholder": "z. B. Leuchttürme, Käse, Raumfahrt …",
    "themeHint": "Die letzte Runde dreht sich dann um euer Thema – zuerst aus unserem recherchierten Fragenpool, notfalls ergänzt durch gegengeprüfte KI-Fragen.",
    "themeLoading": "Mara stellt eure Themenrunde zusammen …",
    "themeReady": "Themenrunde steht: {n} Fragen (davon {ki} KI-Fragen).",
    "themeNone": "Zu „{topic}“ hat Mara leider nichts gefunden – die letzte Runde bleibt gemischt.",
    "guests": "Ausbaustufe {level} – heute im Anker: {guests}",
    "tip": "Trinkgeld der Gäste: +{n} Taler"
  },
  "settings": {
    "title": "Einstellungen",
    "audio": "Ton",
    "vol": {
      "master": "Gesamt",
      "music": "Musik",
      "ambience": "Atmosphäre",
      "sfx": "Effekte"
    },
    "view": "Darstellung & Barrierefreiheit",
    "fontScale": "Schriftgröße",
    "colorblind": "Farbsehschwäche-Modus (Blau/Orange statt Grün/Rot)",
    "subtitles": "Untertitel für Geräusche",
    "reducedMotion": "Bewegung reduzieren",
    "keys": "Tastaturkürzel",
    "key": {
      "esc": {
        "key": "Esc",
        "what": "Menü / Fenster schließen"
      },
      "h": {
        "key": "H",
        "what": "Hinweis"
      },
      "a": {
        "key": "A",
        "what": "Aufgaben"
      },
      "k": {
        "key": "K",
        "what": "Stadtkarte"
      },
      "space": {
        "key": "Leertaste",
        "what": "Hotspots zeigen"
      },
      "f": {
        "key": "F",
        "what": "Vollbild"
      },
      "num": {
        "key": "1–4 / A–D",
        "what": "Antwort im Quiz wählen"
      },
      "right": {
        "key": "Rechtsklick",
        "what": "Untersuchen (Szene und Inventar)"
      }
    }
  },
  "party": {
    "title": "Quizabend – Partymodus",
    "progress": "Runde {r}/{rr} · Frage {q}/{qq}",
    "codeShort": "Raum",
    "reconnecting": "Verbindung wird wiederhergestellt …",
    "connecting": "Verbinde …",
    "qrAlt": "QR-Code zum Beitreten",
    "joinWith": "Mit dem Handy beitreten:",
    "waitingTeams": "Noch keine Teams – scannt den QR-Code!",
    "playersJoined": "{n} Spieler im Raum",
    "start": "Quizabend starten",
    "kind": {
      "normal": "Fragerunde",
      "estimate": "Schätzduell",
      "buzzer": "Buzzer-Runde"
    },
    "kindHint": {
      "normal": "Alle Teams antworten auf ihren Handys – jedes Team einmal.",
      "estimate": "Alle schätzen – das Team, das am nächsten dran ist, bekommt einen Bonuspunkt.",
      "buzzer": "Wer zuerst buzzert, darf antworten: richtig +2, falsch −1 – dann sind die anderen dran."
    },
    "answerOnPhones": "Antwortet auf euren Handys!",
    "buzzerOpen": "Buzzer frei!",
    "buzzed": "{team} hat gebuzzert!",
    "revealNow": "Jetzt auflösen",
    "wagerOnPhones": "Setzt euren Einsatz auf den Handys.",
    "guest": "Gast",
    "roomCode": "Raumcode",
    "yourName": "Dein Name",
    "join": "Beitreten",
    "points": "Punkte",
    "chooseTeam": "Wähle dein Team",
    "newTeam": "Neues Team …",
    "color": "Teamfarbe",
    "createTeam": "Team gründen",
    "waitStart": "Gleich geht’s los!",
    "yourTeam": "Dein Team",
    "switchTeam": "Team wechseln",
    "place": "Platz {n}",
    "lookAtTv": "Schaut auf den Fernseher!",
    "lockedOut": "Ihr seid für diese Frage raus.",
    "buzz": "BUZZ!",
    "teamAnswered": "Euer Team hat geantwortet",
    "waitReveal": "Warten auf die Auflösung …",
    "noAnswer": "Keine Antwort",
    "setWager": "Einsatz setzen",
    "current": "Aktuell",
    "mod": {
      "round": {
        "normal": [
          "Runde {n}: {cat}! Handys raus, Köpfe an.",
          "Weiter mit Runde {n} – {cat}. Ich bin gespannt!"
        ],
        "estimate": [
          "Schätzduell! Jetzt zählt Bauchgefühl.",
          "Runde {n}: Schätzen! Wer am nächsten dran ist, gewinnt."
        ],
        "buzzer": [
          "Buzzer-Runde! Finger auf die Knöpfe …",
          "Jetzt wird’s laut: Buzzer-Runde!"
        ]
      },
      "buzz": [
        "{team} war am schnellsten!",
        "Ding! {team} hat den Finger vorn."
      ],
      "buzzWrong": [
        "Oh nein, {team}! Der Buzzer ist wieder frei.",
        "Daneben, {team}. Die anderen dürfen!"
      ],
      "right": [
        "Stark, {team}!",
        "Punkt für {team}!",
        "{team} weiß Bescheid!"
      ],
      "none": [
        "Niemand? Dann gibt’s jetzt die Erklärung.",
        "Uff – die Frage hat alle versenkt."
      ],
      "standings": [
        "Zwischenstand: {team} führt!",
        "{team} segelt vorneweg."
      ],
      "wager": [
        "Schlussrunde! Kategorie: {cat}. Setzt eure Punkte!",
        "Letzte Frage aus {cat}. Wie mutig seid ihr?"
      ],
      "final": [
        "Die letzte Frage des Abends!",
        "Jetzt zählt’s!"
      ],
      "awards": [
        "Der Sieg geht an {team}! Ding, ding, ding!",
        "Glückwunsch, {team}!"
      ],
      "themeNone": [
        "Zu „{topic}“ hab ich nichts gefunden – dann eben bunt gemischt!"
      ],
      "game": {
        "schocken": "Schocken! Drei Würfel, drei Würfe, und wer am Ende die meisten Deckel hat, gibt einen aus.",
        "knobeln": "Knobeln! Münzen in die Faust, Gesamtzahl raten – wer richtig liegt, ist raus. Der Letzte zahlt."
      },
      "gameOver": "{name} hat verloren – und gibt die nächste Runde aus. Prost!"
    },
    "orderTheme": "Bestellen",
    "gameEnd": "Spiel beenden",
    "gamesHint": "Warm werden mit einem Kneipenspiel (alle Handys spielen mit):"
  },
  "report": {
    "title": "Frage melden",
    "thanks": "Danke! Die Frage ist gesperrt.",
    "reason": {
      "wrong": "Antwort falsch",
      "unclear": "Unklar",
      "outdated": "Veraltet",
      "other": "Sonstiges"
    }
  },
  "daily": {
    "title": "Tagesrätsel",
    "offline": "Das Tagesrätsel braucht eine Verbindung zum Server.",
    "shareTitle": "Die letzte Runde – Tagesrätsel {date}",
    "gridAlt": "{n} von {m} richtig",
    "score": "{n} von {m} richtig",
    "comeBack": "Morgen gibt es ein neues Rätsel – für alle das gleiche.",
    "share": "Ergebnis teilen",
    "copied": "In die Zwischenablage kopiert!",
    "toResult": "Zum Ergebnis"
  },
  "meta": {
    "collected": "Bierdeckel gefunden",
    "coins": "Taler",
    "title": "Kneipe & Logbuch",
    "open": "Kneipe & Logbuch",
    "level": "Ausbaustufe {level}",
    "nextLevel": "Noch {n} Ausbauten bis Stufe {level}",
    "maxLevel": "Höchste Stufe erreicht!",
    "tab": {
      "shop": "Ausbau",
      "training": "Training",
      "log": "Logbuch",
      "stats": "Statistik",
      "ach": "Erfolge",
      "coll": "Sammlung"
    },
    "buy": "Kaufen",
    "bought": "Erledigt",
    "needs": "Erst: {name}",
    "repair": "Reparatur",
    "deco": "Deko",
    "earnHint": "Taler gibt es für richtige Antworten – im Abenteuer, im Training, beim Tagesrätsel und als Trinkgeld nach dem Quizabend.",
    "guests": "Gäste",
    "guestAt": "ab Stufe {level}",
    "trainingIntro": "Stammtisch-Training: 10 Fragen aus allen Kategorien. Jede richtige Antwort bringt {n} Taler.",
    "trainingStart": "Training starten",
    "trainingNext": "Weiter",
    "trainingDone": "Training beendet: {r} von {n} richtig.",
    "trainingAgain": "Noch eine Runde",
    "logEmpty": "Noch keine Fragen beantwortet.",
    "filterAll": "Alle",
    "filterWrong": "Nur falsche",
    "source": "Quelle",
    "statsTotal": "{r} von {n} richtig ({p} %)",
    "bestStreak": "Beste Serie: {n}",
    "noStats": "Noch keine Statistik.",
    "achCount": "{n} von {m} Erfolgen",
    "collCount": "{n} von {m} Bierdeckeln",
    "notFound": "Noch nicht gefunden",
    "close": "Schließen",
    "mode": {
      "adventure": "Abenteuer",
      "show": "Quizabend",
      "daily": "Tagesrätsel",
      "training": "Training",
      "party": "Party"
    }
  },
  "ach": {
    "unlocked": "Erfolg freigeschaltet",
    "first_answer": {
      "name": "Erste Frage",
      "desc": "Eine Quizfrage beantwortet."
    },
    "first_right": {
      "name": "Volltreffer",
      "desc": "Die erste richtige Antwort."
    },
    "right_10": {
      "name": "Kneipenwissen",
      "desc": "10 richtige Antworten."
    },
    "right_50": {
      "name": "Stammgast",
      "desc": "50 richtige Antworten."
    },
    "right_100": {
      "name": "Quizkapitän",
      "desc": "100 richtige Antworten."
    },
    "right_250": {
      "name": "Lebendes Lexikon",
      "desc": "250 richtige Antworten."
    },
    "streak_5": {
      "name": "Lauf",
      "desc": "5 richtige in Folge."
    },
    "streak_10": {
      "name": "Glückssträhne",
      "desc": "10 richtige in Folge."
    },
    "streak_20": {
      "name": "Unaufhaltsam",
      "desc": "20 richtige in Folge."
    },
    "cats_5": {
      "name": "Neugierig",
      "desc": "Fragen aus 5 Kategorien beantwortet."
    },
    "cats_all": {
      "name": "Allrounder",
      "desc": "Fragen aus allen 15 Kategorien beantwortet."
    },
    "master_1": {
      "name": "Fachfrau, Fachmann",
      "desc": "Eine Kategorie gemeistert (10 richtig, ≥ 70 %)."
    },
    "master_3": {
      "name": "Dreifach-Meister",
      "desc": "Drei Kategorien gemeistert."
    },
    "coins_100": {
      "name": "Erste Taler",
      "desc": "100 Taler verdient."
    },
    "coins_500": {
      "name": "Volle Kasse",
      "desc": "500 Taler verdient."
    },
    "coins_1000": {
      "name": "Hafenbaron",
      "desc": "1.000 Taler verdient."
    },
    "first_upgrade": {
      "name": "Anpacken",
      "desc": "Den ersten Ausbau gekauft."
    },
    "level_1": {
      "name": "Aufgeräumt",
      "desc": "Ausbaustufe 1 erreicht."
    },
    "level_2": {
      "name": "Gemütlich",
      "desc": "Ausbaustufe 2 erreicht."
    },
    "level_3": {
      "name": "Beliebt",
      "desc": "Ausbaustufe 3 erreicht."
    },
    "level_4": {
      "name": "Geheimtipp",
      "desc": "Ausbaustufe 4 erreicht."
    },
    "level_5": {
      "name": "Beste Kneipe am Hafen",
      "desc": "Ausbaustufe 5 erreicht."
    },
    "all_repairs": {
      "name": "Handwerker",
      "desc": "Alle Reparaturen erledigt."
    },
    "all_deco": {
      "name": "Innenarchitekt",
      "desc": "Alle Deko-Elemente gekauft."
    },
    "coaster_1": {
      "name": "Sammler",
      "desc": "Den ersten seltenen Bierdeckel gefunden."
    },
    "coaster_6": {
      "name": "Halbe Sammlung",
      "desc": "6 Bierdeckel gefunden."
    },
    "coaster_all": {
      "name": "Komplett",
      "desc": "Alle 12 Bierdeckel gefunden."
    },
    "chapter_1": {
      "name": "Die letzte Runde",
      "desc": "Kapitel 1 abgeschlossen."
    },
    "chapter_2": {
      "name": "Durch den Nebel",
      "desc": "Kapitel 2 abgeschlossen."
    },
    "show_played": {
      "name": "Quizabend",
      "desc": "Einen Quizabend gespielt."
    },
    "show_5": {
      "name": "Quizmaster",
      "desc": "5 Quizabende gespielt."
    },
    "daily_1": {
      "name": "Tagesrätsel",
      "desc": "Ein Tagesrätsel gespielt."
    },
    "training_3": {
      "name": "Fleißig",
      "desc": "3 Stammtisch-Trainings abgeschlossen."
    },
    "logbook_100": {
      "name": "Logbuch voll",
      "desc": "100 Einträge im Logbuch."
    },
    "smalltalk": {
      "name": "Klönschnack",
      "desc": "Mit einem Stammgast geplaudert."
    },
    "game_won": {
      "name": "Glückspilz",
      "desc": "Ein Kneipenspiel gewonnen."
    },
    "games_5": {
      "name": "Spielernatur",
      "desc": "5 Kneipenspiele gespielt."
    },
    "secret": {
      "name": "Geheimniskrämer",
      "desc": "Ein Geheimnis der Stammgäste gelüftet."
    },
    "chapter_3": {
      "name": "Pate gefunden",
      "desc": "Kapitel 3 abgeschlossen."
    },
    "chapter_4": {
      "name": "Buch zurück",
      "desc": "Kapitel 4 abgeschlossen."
    },
    "chapter_5": {
      "name": "Nordsee-Pokal",
      "desc": "Kapitel 5 abgeschlossen."
    },
    "all_endings": {
      "name": "Alle Wege",
      "desc": "Alle drei Enden erlebt."
    },
    "allies_6": {
      "name": "Die halbe Stadt",
      "desc": "Sechs Verbündete gewonnen."
    }
  },
  "npcName": {
    "gesa": "Gesa",
    "jan": "Jan",
    "ole": "Ole",
    "pieper": "Kapitän Pieper",
    "ilse": "Ilse",
    "brakenhoff": "Brakenhoff"
  },
  "upgrades": {
    "clean": {
      "name": "Großputz",
      "desc": "Spinnweben, Scherben und Staub verschwinden."
    },
    "window": {
      "name": "Fenster verglasen",
      "desc": "Die gesprungene Scheibe wird ersetzt."
    },
    "lights": {
      "name": "Elektrik flicken",
      "desc": "Alle Lampen brennen wieder ruhig."
    },
    "stove": {
      "name": "Ofen anheizen",
      "desc": "Rohr gefegt, Feuer an – endlich warm."
    },
    "walls": {
      "name": "Wände streichen",
      "desc": "Wasserflecken und Schimmel sind weg."
    },
    "floor": {
      "name": "Dielen ölen",
      "desc": "Der Boden glänzt wie frisch geschrubbtes Deck."
    },
    "jukebox": {
      "name": "Musikbox reparieren",
      "desc": "Die alte Box spielt wieder Seemannslieder."
    },
    "stools": {
      "name": "Barhocker leimen",
      "desc": "Keine wackeligen Hocker mehr am Tresen."
    },
    "tables": {
      "name": "Zweiter Tisch",
      "desc": "Platz für ein weiteres Quizteam."
    },
    "taps": {
      "name": "Zapfanlage polieren",
      "desc": "Messing, das blitzt."
    },
    "shelf": {
      "name": "Regal auffüllen",
      "desc": "Volle Flaschenreihen hinter dem Tresen."
    },
    "darts": {
      "name": "Neue Dartscheibe",
      "desc": "Mit frischen Pfeilen."
    },
    "plants": {
      "name": "Grüne Ecke",
      "desc": "Frische Pflanzen statt vertrockneter Stängel."
    },
    "garland": {
      "name": "Lichterkette",
      "desc": "Warmes Licht quer durch den Raum."
    },
    "candles": {
      "name": "Kerzen",
      "desc": "Auf jedem Tisch eine Kerze."
    },
    "net": {
      "name": "Fischernetz",
      "desc": "Ein echtes Netz mit Glaskugeln unter der Decke."
    },
    "flags": {
      "name": "Signalflaggen",
      "desc": "Eine Flaggenleine – wer kann sie lesen?"
    },
    "ships": {
      "name": "Buddelschiff",
      "desc": "Ein zweites Schiffsmodell fürs Fensterbrett."
    },
    "photos": {
      "name": "Fotowand",
      "desc": "Alte Bilder der Quizabende seit 1922."
    },
    "carpet": {
      "name": "Teppich",
      "desc": "Ein dicker Läufer vor dem Tresen."
    },
    "lamps": {
      "name": "Neue Lampen",
      "desc": "Zwei zusätzliche Hängelampen."
    },
    "vitrine": {
      "name": "Pokalvitrine",
      "desc": "Für die Pokale der Quizabende."
    },
    "sign": {
      "name": "Neues Schild",
      "desc": "„Zum Rostigen Anker“ – frisch gemalt."
    },
    "bell": {
      "name": "Goldene Glocke",
      "desc": "Die Quizglocke, vergoldet. Ehrensache."
    }
  },
  "coasters": {
    "c01": "Rostiger Anker 1922",
    "c02": "Hinnerks Stammdeckel",
    "c03": "Möwe II",
    "c04": "Krämergasse",
    "c05": "Leuchtfeuer",
    "c06": "Kutterkapitän",
    "c07": "Reederei",
    "c08": "Fährdeckel",
    "c09": "Nebelfahrt",
    "c10": "Möwensand",
    "c11": "Sandbank",
    "c12": "Ilses Liebling"
  },
  "online": {
    "title": "Online-Pubquiz",
    "guest": "Gast",
    "whoAreYou": "Wer spielt?",
    "playingAs": "Du spielst als {name}.",
    "guestHint": "Ohne Konto spielst du als Gast. Mit Konto behältst du Spitzname, Avatar und Spielstand auf allen Geräten.",
    "publicRooms": "Öffentliche Räume",
    "noRooms": "Gerade ist kein öffentlicher Raum offen – eröffne doch einen!",
    "open": "offen",
    "running": "läuft",
    "playersTeams": "{p} Spieler · {t} Teams",
    "newRoom": "Raum eröffnen",
    "roomTitle": "Name des Abends",
    "defaultTitle": "Quizabend im Netz",
    "visibility": "Wer darf rein?",
    "public": "Öffentlich (in der Liste)",
    "private": "Privat (nur per Einladungslink)",
    "answerMode": "Wie antwortet ein Team?",
    "mode": {
      "vote": "Abstimmung",
      "captain": "Kapitän entscheidet"
    },
    "modeHint": {
      "vote": "Jedes Teammitglied stimmt ab, die Mehrheit zählt.",
      "captain": "Alle dürfen Vorschläge machen, der Kapitän (⚓) gibt die Antwort ab."
    },
    "rounds": "Runden",
    "perRound": "Fragen je Runde",
    "create": "Raum eröffnen",
    "invite": "Einladen",
    "inviteText": "Komm in unser Online-Pubquiz „{title}“!",
    "joinTeam": "Beitreten",
    "start": "Quizabend starten",
    "waitOwner": "Warte, bis der Gastgeber startet …",
    "captain": "Kapitän",
    "youCaptain": "Du bist Kapitän",
    "proposeHint": "Dein Vorschlag geht an den Kapitän.",
    "voted": "Abgestimmt: {n} von {m}",
    "captainWagers": "Der Kapitän setzt den Einsatz.",
    "backToLobby": "Zur Lobby",
    "scores": "Punktestand",
    "double": "Doppelt",
    "chatPlaceholder": "Nachricht ans Team …",
    "send": "Senden",
    "captainHint": "Tipp: Als Kapitän gibst du die Antworten ab.",
    "mod": {
      "lobby": "Moin! Ich bin Mara und moderiere „{title}“. Teams bilden – und wenn alle da sind, geht’s los."
    },
    "chatLabel": "Team-Chat"
  },
  "account": {
    "title": "Konto",
    "login": "Anmelden",
    "register": "Registrieren",
    "username": "Benutzername",
    "password": "Passwort",
    "nickname": "Spitzname",
    "team": "Stammteam",
    "teamHint": "z. B. Die Heringsbändiger",
    "avatar": "Avatar",
    "random": "Zufall",
    "prev": "{part} zurück",
    "next": "{part} weiter",
    "saveProfile": "Profil speichern",
    "saved": "Gespeichert.",
    "logout": "Abmelden",
    "cloudOn": "Cloud-Spielstand aktiv",
    "cloudSaving": "Wird gesichert …",
    "cloudSaved": "In der Cloud gesichert ({time})",
    "cloudError": "Sichern gerade nicht möglich",
    "cloudNow": "Jetzt sichern",
    "why": "Mit Konto liegen Kneipe, Erfolge, Logbuch und Spielstände in der Cloud – auf jedem Gerät weiterspielen.",
    "part": {
      "skin": "Haut",
      "hair": "Frisur",
      "hairColor": "Haarfarbe",
      "beard": "Bart",
      "hat": "Mütze",
      "glasses": "Brille",
      "shirt": "Pullover",
      "bg": "Hintergrund"
    }
  },
  "mem": {
    "first": "Moin! Wir kennen uns noch nicht richtig. Setz dich ruhig dazu.",
    "again": "Na, da bist du ja wieder. Das ist jetzt schon unser {n}. Treffen.",
    "wrongFav": "Sag mal – neulich die Frage „{prompt}“? Das war {answer}! Ich hab’s dir doch angesehen, dass du zögerst.",
    "rightFav": "Respekt: „{prompt}“ – {answer}, ganz richtig. Das hätte ich dir nicht zugetraut.",
    "lostGame": "Das {game} letztes Mal … reden wir nicht drüber. Revanche?",
    "wonGame": "Na, noch Lust auf {game}? Letztes Mal hab ich dich ja ordentlich abgezogen.",
    "achievement": "Ich hab gehört: „{ach}“! Darauf einen Köm.",
    "level": "Schick ist es hier geworden! Ausbaustufe {level} – Hinnerk wär stolz.",
    "lastTalk": "Du hattest doch letztes Mal gesagt: „{said}“ – da musste ich noch lange drüber nachdenken.",
    "ole": {
      "first": "Hm. Moin. Ole. Ich sitz hier nur.",
      "wrongFav": "„{prompt}“. {answer}, Deern. Weiß jeder, der mal auf’m Turm war.",
      "again": "Schon wieder du. Hm. Setz dich."
    },
    "brakenhoff": {
      "first": "Frau Jansen. Ich bin nur wegen des Quiz hier. Nicht wegen Ihnen.",
      "lostGame": "Das {game}? Glück, Frau Jansen. Reines Glück. Revanche, sofort.",
      "wrongFav": "„{prompt}“ – {answer}, Frau Jansen. Das ist Allgemeinbildung."
    },
    "jan": {
      "first": "Ah, Frau Jansen! Darf ich Ihnen ein Glas spendieren?",
      "wrongFav": "Ich muss es loswerden: „{prompt}“ – die Antwort ist {answer}. Steht in jedem guten Buch."
    }
  },
  "guest": {
    "placeholder": "Was willst du {name} sagen?",
    "thinking": "überlegt …",
    "noAnswer": "… (zuckt nur mit den Schultern)",
    "afterWin": "Ha! {game} kann ich eben. Noch eine Runde?",
    "afterLoss": "Na gut, na gut. Beim {game} hast du gewonnen. Ich geb einen aus.",
    "hint": "Tipp: Stammgäste erinnern sich an eure Gespräche, Spiele und Quizantworten. Manche haben Geheimnisse – frag nach ihren Lieblingsthemen.",
    "logLabel": "Gespräch mit {name}"
  },
  "games": {
    "schocken": "Schocken",
    "knobeln": "Knobeln",
    "playSchocken": "Schocken spielen",
    "playKnobeln": "Knobeln spielen",
    "rules": {
      "schocken": "Bis zu drei Würfe, Würfel antippen zum Liegenlassen. Schock aus (1-1-1) schlägt alles, dann Schock (1-1-x), General, Straße, Zahl. Das schlechteste Blatt bekommt Deckel; sind die 13 Deckel verteilt, verliert, wer die meisten hat.",
      "knobeln": "Verdeckt 0–3 Münzen nehmen, dann reihum die Gesamtzahl raten – jede Zahl nur einmal. Wer richtig rät, ist raus. Der Letzte verliert."
    },
    "deckel": "Deckel",
    "pot": "Mitte: {n} Deckel",
    "round": "Runde {n}",
    "die": "Würfel {n} {held}",
    "held": "(liegt)",
    "yourThrow": "Dein Wurf {n} von {max}",
    "theirTurn": "{name} ist dran …",
    "roll": "Würfeln",
    "stand": "Stehen lassen",
    "roundResult": "{loser} bekommt {n} Deckel – {winner} hatte das beste Blatt.",
    "out": "raus",
    "knTotal": "Zusammen: {n} Münzen.",
    "knHit": "{name} hat richtig geraten!",
    "knNoHit": "Niemand lag richtig.",
    "knHide": "Wie viele Münzen nimmst du in die Faust?",
    "knGuess": "Du hast {own}. Wie viele sind es insgesamt (0–{max})?",
    "knGuessLabel": "Dein Tipp",
    "knGuessOk": "Tippen",
    "wait": "Gleich geht’s weiter …",
    "won": "Gewonnen!",
    "lost": "Verloren!",
    "wonText": "{name} gibt die Runde aus.",
    "lostText": "Du gibst die Runde aus. Prost!",
    "done": "Weiter",
    "wonToast": "Gewonnen gegen {name}"
  },
  "story": {
    "unlocked": "Neuer Story-Weg",
    "ole": "Oles Geheimnis – die lose Stufe im Leuchtturm",
    "ole_found": "Hinnerks Trinkgeldkasse gefunden",
    "jan": "Jans Seekarte – ein Kreuz am Hafenkai",
    "jan_found": "Hinnerks Notgroschen gefunden",
    "brakenhoff": "Brakenhoffs Pokal-Replik steht im Anker",
    "ally_pastorin": "Pastorin Harms klatscht beim Pokal mit",
    "ally_baeckerin": "Hanne bringt Butterkuchen zum Pokal",
    "ally_bibliothek": "Frau Lüders drückt leise die Daumen",
    "ally_uhrmacher": "Tönnies stoppt beim Pokal die Zeit",
    "ally_zoellner": "Verbündete: Zollinspektorin Behrens",
    "ally_bootsbauer": "Verbündeter: Bootsbauer Ocke",
    "ally_fischfrau": "Verbündete: Fischfrau Wiebke",
    "ally_dittmers": "Verbündeter: Hauke Dittmers von der Makrele",
    "ally_schausteller": "Verbündete: Schaustellerin Wilma und ihr Riesenrad",
    "ally_shantychor": "Verbündete: Shanty-Chor „Windstärke 9“",
    "ally_techniker": "Verbündeter: Bühnentechniker Bodo"
  },
  "map": {
    "title": "Stadtkarte",
    "alt": "Karte der Hafenstadt mit ihren Vierteln",
    "unknown": "noch nicht entdeckt",
    "wait": "Warten bis {next}"
  },
  "time": {
    "0": "Morgen",
    "1": "Mittag",
    "2": "Abend",
    "3": "Nacht"
  },
  "district": {
    "hafen": "Hafen",
    "altstadt": "Altstadt",
    "oberstadt": "Oberstadt",
    "werft": "Werft & Speicherstadt",
    "festplatz": "Festplatz",
    "moewensand": "Möwensand"
  }
}